import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'rms-text-content-history-modal',
    templateUrl: './text-content-history-modal.component.html',
    styleUrls: ['./text-content-history-modal.component.scss'],
    standalone: false
})
export class TextContentHistoryModalComponent implements OnInit {

  @ViewChild('textContentHistoryModal', { static: true }) historyModal: ElementRef;
  public data: Array<any> = [];
  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  /**
   * Opens the history modal
   * @param data
   */
  public openModal (data: Array<any>) {
    this.modalService.open(this.historyModal, {size: 'lg'});
    data.forEach(item => item.isOpen = true);
    this.data = data;
  }

}
